import { lazy } from 'react'

import { ModalRouteNode, RouteConfig } from 'packages/route'

export const routes: RouteConfig[] = [
  {
    path: 'admin/test-paper',
    getTitle: () => '试卷管理',
    name: 'AdminTestPaperList',
    component: lazy(() =>
      import('./pages/List').then((m) => ({
        default: m.List,
      }))
    ),
  },
]

export const modalRoutes: ModalRouteNode[] = [
  {
    getTitle: () => '编辑试卷',
    name: 'EditTestPaper',
    component: lazy(() =>
      import('./pages/EditPaper').then((m) => ({
        default: m.EditPaperEntry,
      }))
    ),
  },
]
